import script from "./OfferDocDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferDocDetail.vue?vue&type=script&setup=true&lang=js"

import "./OfferDocDetail.vue?vue&type=style&index=0&id=8432e3ce&lang=css"

const __exports__ = script;

export default __exports__